import type { EligibilityCheck } from '../policies/picker-candidates.policy';
import { LEGAL_BLOCK_LABEL } from '../policies/check-reasons.policy';

/** Every check that blocks, with its words and code; a legal one says it cannot be overridden. */
export function BlockedChecks({ id, checks }: { id: string; checks: EligibilityCheck[] }) {
  return (
    <ul id={id} className="mt-2 ml-8 flex flex-col gap-1 text-xs">
      {checks.map((check) => (
        <li key={`${check.check}:${check.code}`} className="flex flex-wrap gap-x-2">
          <span className="font-medium text-fg">{check.check.replaceAll('_', ' ')}</span>
          <span className="text-muted">{check.reason ?? check.code}</span>
          {check.nonOverridable === true && <span className="text-error">{LEGAL_BLOCK_LABEL}</span>}
        </li>
      ))}
    </ul>
  );
}
